import { OtpMapper } from './OtpMapper.js';

class OtpRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  sendPhoneNumberVerification(params) {
    return this.apiClient.post('/v1/otp/client/send', params).then(response => OtpMapper.createFromResponse(response.data));
  }
  verifyOtpCode(params) {
    return this.apiClient.post('/v1/otp/client/verify', params).then(response => response.data);
  }
  getOtpStatus() {
    return this.apiClient.get('/v1/otp/status').then(response => response.data);
  }
}

export { OtpRepository };
//# sourceMappingURL=OtpRepository.js.map
